export default __webpack_public_path__ + "static/coach-9ea65a763fa907071cf24228cddd9a1f.jpg";